import type { Route } from '~/core/router'

import * as pinLockFeature from '~/features/pin-lock'
import { AccountSettingsModal } from '~/features/portal/redirect'
import * as root from '~/routes/404/root'
import { keys } from '~/shared/jail'
import { Footer } from '~/shared/ui/components/Footer'
import { NavBar } from '~/widgets/NavBar'
import { ProfilesRemovePopup } from '~/widgets/Popups'

export const route: Route = {
  keys: [keys.app, keys.guest],

  children: [
    {
      path: '',
      component: [
        root.Title,
        NavBar,
        root.NotFoundPage,
        Footer,
        ProfilesRemovePopup,
        AccountSettingsModal,
        pinLockFeature.PinLockPopup,
      ],
      init: root.model.init,
    },
  ],
}
